import { notification } from "antd";
import { captureEvent } from '@sentry/browser';
import isProgressive from "./is-progressive";
import checkColorProfile from "./check-color-profile";

const ERROR = {
  TOO_LARGE: "Image must be smaller than 50MB!",
  NOT_PROGRESSIVE: "Error: Image is a Progressive jpeg which is not supported. Please resave the file as a normal (Baseline) jpeg.",
  NOT_RGB: "Error: Image is CMYK or Grayscale Color Mode. Only RGB images are supported. Please convert the image to RGB."
};

export const tosValidator = (rule, value, callback) => {
  if (value) {
    return callback();
  }
  callback("You must agree to the terms of use");
};

export const validImage = async file => {
  const isValidSize = file.size / 1024 / 1024 < 50;
  if (!isValidSize) {
    notification.error({ message: ERROR.TOO_LARGE, duration: 0, description: file.name });
    captureEvent({
      level: 'info',
      message: ERROR.TOO_LARGE,
      tags: {
        source: 'upload'
      }
    });
    return Promise.reject(ERROR.TOO_LARGE);
  } else if (file.type === "image/jpeg" || file.type === "image/jpg") {
    const color = await checkColorProfile(file);
    if (color !== "RGB") {
      captureEvent({
        level: 'info',
        message: ERROR.NOT_RGB,
        tags: {
          source: 'upload'
        }
      });
      notification.error({ message: ERROR.NOT_RGB, duration: 0, description: file.name });
      return Promise.reject(ERROR.NOT_RGB);
    }
    const progressive = await isProgressive(file);
    if (progressive) {
      captureEvent({
        level: 'info',
        message: ERROR.NOT_PROGRESSIVE,
        tags: {
          source: 'upload'
        }
      });
      notification.error({ message: ERROR.NOT_PROGRESSIVE, duration: 0, description: file.name });
      return Promise.reject(ERROR.NOT_PROGRESSIVE);
    }
  }
};
